import { queryOptions } from '@tanstack/react-query';
import { Domain, } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
export const bankAccountKeys = {
    all: ['bankAccounts'],
    get: (filter) => ['bankAccounts', filter],
};
export const bankAccountOptions = {
    get: (filter) => queryOptions({
        queryKey: bankAccountKeys.get(filter),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.BankAccount);
            return repo.get(filter);
        },
    }),
    create: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.BankAccount);
            return repo.create(request);
        },
    }),
    updateName: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.BankAccount);
            return repo.updateName(request);
        },
    }),
};
